import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import React from 'react';
import { ShareLinkError } from '../../../services';

// #region ShareErrorViewProps
export interface ShareErrorViewProps {
    error: ShareLinkError;
    onRetry: () => void;
}

const ERROR_MESSAGES: Record<ShareLinkError, { title: string; body: string }> = {
    INVALID: {
        title: 'Link not available',
        body: 'This link is invalid or has been revoked.'
    },
    EXPIRED: {
        title: 'Link expired',
        body: 'This link has expired — ask your designer to send a new one.'
    },
    GENERIC: {
        title: 'Something went wrong',
        body: 'We could not load your project. Please try again.'
    }
};

// #region ShareErrorView
// Full-page static error state for the magic link (light mode only).
export const ShareErrorView: React.FunctionComponent<ShareErrorViewProps> = (props: ShareErrorViewProps): JSX.Element => {
    const { error, onRetry } = props;
    const message = ERROR_MESSAGES[error];

    return (
        <div className="flex min-h-[60vh] flex-col items-center justify-center px-6 text-center">
            <ExclamationTriangleIcon className="h-12 w-12 text-share-muted" />
            <h1 className="mt-4 text-xl font-semibold text-share-text">{message.title}</h1>
            <p className="mt-2 max-w-sm text-sm text-share-muted">{message.body}</p>
            {error === 'GENERIC' && (
                <button
                    type="button"
                    onClick={onRetry}
                    style={{ backgroundColor: 'var(--share-primary)', color: 'var(--share-primary-contrast)' }}
                    className="mt-6 min-h-[48px] rounded-xl px-6 text-sm font-semibold shadow-sm transition hover:brightness-110"
                >
                    Retry
                </button>
            )}
        </div>
    );
};
